import React from "react";
import "./card.css"

// Card do Projeto — tema espacial
const Card = ({ image, name, title, description, link, tags = [] }) => {
  return (
    <article className="c-card" data-reveal>
      <div className="c-card__halo" aria-hidden="true" />
      <div className="c-card__media">
        {image && (typeof image === 'string' ? (
          <img src={image} alt={name} className="c-card__img" loading="lazy" decoding="async" />
        ) : (
          <picture>
            {image.avif && <source type="image/avif" srcSet={image.avif} />}
            {image.webp && <source type="image/webp" srcSet={image.webp} />}
            <img src={image.src || image.png || image.fallback} alt={name} className="c-card__img" loading="lazy" decoding="async" />
          </picture>
        ))}
      </div>
      <div className="c-card__body">
        <h3 className="c-card__title">{name}</h3>
        {title && <p className="c-card__subtitle">{title}</p>}
        {description && <p className="c-card__desc">{description}</p>}
        {tags?.length > 0 && (
          <div className="c-card__tags">
            {tags.map((t, i) => (
              <span key={i} className="c-tag">
                {t}
              </span>
            ))}
          </div>
        )}
        {link && (
          <div className="c-card__actions">
            <a className="c-button" href={link} target="_blank" rel="noreferrer">
              Ver Site
            </a>
          </div>
        )}
      </div>
      {link && <a className="c-card__link" href={link} target="_blank" rel="noreferrer" aria-label={`Abrir ${name}`} />}
    </article>
  );
};

// Lista de Cards (grid responsivo)
const CardList = ({ cards = [] }) => {
  return (
    <div className="c-cards">
      {cards.map((card, index) => (
        <Card
          key={index}
          image={card.image}
          name={card.name}
          title={card.title}
          description={card.description}
          link={card.link}
          tags={card.tags}
        />
      ))}
    </div>
  );
};

export default CardList;
export { Card };
